/**
 * Menu Image Hover
 * Changes the navigation overlay image based on which menu link is hovered
 */

class MenuImageHover {
  constructor() {
    console.log('🖼️ MenuImageHover constructor called');
    this.navOverlay = document.getElementById('primary-menu');
    this.navImage = document.querySelector('.nav-overlay-image__img');
    this.defaultImageSrc = '';
    this.resetTimeout = null; // Add timeout variable

    console.log('navOverlay:', this.navOverlay);
    console.log('navImage:', this.navImage);

    if (this.navOverlay && this.navImage) {
      this.init();
    } else {
      console.error('❌ MenuImageHover: Missing required elements');
    }
  }

  init() {
    console.log('🎬 MenuImageHover init');
    
    // Store default image source
    this.defaultImageSrc = this.navImage.src;
    console.log('Default image:', this.defaultImageSrc);

    // Set active page image on load first
    const activeLink = this.navOverlay.querySelector('.nav-section-menu li.active a[data-menu-image], .nav-section-menu a.active[data-menu-image]');
    if (activeLink && activeLink.dataset.menuImage) {
      console.log('✅ Active page link found:', activeLink.textContent, activeLink.dataset.menuImage);
      this.navImage.src = activeLink.dataset.menuImage;
      this.navImage.srcset = activeLink.dataset.menuImage; // Also update srcset
      this.defaultImageSrc = activeLink.dataset.menuImage;
    } else {
      console.log('ℹ️ No active page link found');
    }

    // Get all menu links
    const menuLinks = this.navOverlay.querySelectorAll('.nav-section-menu a');
    console.log(`Found ${menuLinks.length} menu links`);

    // Set up hover listeners
    menuLinks.forEach((link, index) => {
      const hasImage = !!link.dataset.menuImage;
      console.log(`Link ${index}: "${link.textContent.trim()}" - Has image: ${hasImage}`, link.dataset.menuImage);
      
      link.addEventListener('mouseenter', () => {
        // Clear any pending reset
        if (this.resetTimeout) {
          clearTimeout(this.resetTimeout);
          this.resetTimeout = null;
        }
        
        const imageUrl = link.dataset.menuImage;
        console.log('🖱️ Hover on:', link.textContent.trim(), '- Image:', imageUrl);
        if (imageUrl) {
          console.log('Changing image to:', imageUrl);
          this.navImage.src = imageUrl;
          this.navImage.srcset = imageUrl; // Also update srcset
          this.navImage.sizes = '(max-width: 864px) 100vw, 864px'; // Reset sizes
        } else {
          console.log('⚠️ No image data for this link');
        }
      });
      
      link.addEventListener('mouseleave', () => {
        // Set timeout to reset after 500ms of no hover
        this.resetTimeout = setTimeout(() => {
          console.log('⏱️ Timeout - resetting to default');
          this.navImage.src = this.defaultImageSrc;
          this.navImage.srcset = this.defaultImageSrc;
        }, 500);
      });
    });

    // Reset to default when leaving the entire overlay content area
    const overlayContent = this.navOverlay.querySelector('.nav-overlay-content');
    console.log('overlayContent:', overlayContent);
    if (overlayContent) {
      overlayContent.addEventListener('mouseleave', () => {
        console.log('↩️ Reset to default image:', this.defaultImageSrc);
        this.navImage.src = this.defaultImageSrc;
        this.navImage.srcset = this.defaultImageSrc; // Also reset srcset
      });
    }
    
    console.log('✅ MenuImageHover initialized successfully');
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new MenuImageHover();
  });
} else {
  new MenuImageHover();
}

export default MenuImageHover;
